import sendRequest from "../fetch"
import Qs from 'qs'
import { cleanParams, getApi } from "@/utils";

const _base = "sysSetting/";


// 系统配置信息 - 获取详情
export const configView = (params) => {
  let _params = cleanParams(params);
  return sendRequest(getApi() + _base + "view", {
    data: Qs.stringify(_params),
    method: "GET",
  });
};


// WEBPACK FOOTER //
// ./src/fetch/api/config.js